import { Component, Injector, ViewChild } from '@angular/core';

import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';
import { ConfigService } from '@core/config/config.service';
import { WcmTableComponent } from '@core/globals/wcm-table/wcm-table.component';
import { ISelectedItems, IJobResponse } from '@core/interfaces';
import { WaycomHttpErrorResponse } from '@core/services/waycom-http-error-response';
import { SignalsService } from '@core/services/signals.service';
import {omit} from "lodash-es";

@Component({
  selector: 'app-quotes-list',
  templateUrl: './quotes-list.component.html',
  styleUrls: ['./quotes-list.component.less']
})
export class QuotesListComponent extends GenericListComponent {
  @ViewChild('wcmTable', {static: true}) public wcmTable: WcmTableComponent;

  public salesforceBaseUrl: string;
  public loadingAction: boolean = false;
  public localDisabledColumns = {
    date: true,
    project__name: true,
  };
  public disableTaskExport: boolean = false;

  constructor(
    public injector: Injector,
    private config: ConfigService,
    private readonly signalsService: SignalsService,
  ) {
    super(injector);
    this.salesforceBaseUrl = this.config.salesforceBaseUrl;
  }

  public clearSelection(): void {
    this.wcmTable.unselectAll();
  }

  public bulkUpdateStatus(selectedItems: ISelectedItems, transition_name: string): void {
    this.loadingAction = true;
    this.apiShiva.quotes.bulk_play_transition(Object.keys(selectedItems), transition_name)
      .then((res: IJobResponse) => {
        this.signalsService.broadcastJobStart(res.job_name, res.job_id);
        this.clearSelection();
        this.wcmTable.refreshTable();
      })
      .catch((error: unknown) => this._handleBulkError(error))
      .finally(() => this.loadingAction = false);
  }

  private _handleBulkError(err: unknown): void {
    if (err instanceof WaycomHttpErrorResponse) {
      const errorMap: Record<string, string> = {
        MISSING_QUOTES_CODES: `Aucun devis n'a été fourni lors de la mise à jour.`,
        INCORRECT_QUOTES: `Certains devis n'ont pas pu être récupérés.`,
        COULD_NOT_PATCH_QUOTES_WITH_DIFFERENT_STATUS: `Les devis sélectionnés doivent être au même statut.`,
        COULD_NOT_PATCH_QUOTES: `Les statuts des devis sélectionnés ne convient pas au workflow des devis.`,
        COULD_NOT_PATCH_QUOTES_WITH_SAME_VERSION: `Les devis sélectionnés ne doivent pas être des versions d'un même devis.`
      };
      const errorMessage = errorMap[err.getFirstErrorMessage()];
      if (errorMessage) {
        this.toastr.error(errorMessage);
        return;
      }
    }
    Promise.reject(err);
  }

  public exportQuotes(tableFilters){
    const filters: Pick<any, any> = omit(tableFilters, 'offset', 'limit');
    const taskName: string = 'Export des devis';

    this.disableTaskExport = true
    this.apiShiva.quotes.exportQuotes(filters).then((res) => {
      this.signalsService.broadcastJobStart(taskName, res['job_id'])
      this.toastr.success('Demande prise en compte. Veuillez patienter le temps que le fichier d\'export soit généré.');
    }).catch((err) => {
      this.toastr.error('Echec de la demande d\'export. Veuillez réessayer.')
    }).finally(() =>{
      this.disableTaskExport = false;
    })
  }
}
